import React, {ReactNode} from 'react';
import {css} from '@emotion/react'

interface ErrorToastComponentProps {
	content: ReactNode
	name?: string // required for queue
}

export function ToastContentComponent({content}: ErrorToastComponentProps) {
	const cssRoot = css`
		display: flex;
		align-items: center;
		justify-content: center;
	`
	const cssTwo = css`
		flex-grow: 1;
		white-space: pre-line;
		padding: 8px;
	`
	return (
		<div css={cssRoot}>
			<div css={cssTwo}>
				{content}
			</div>
		</div>
	)
}